module.exports = __webpack_public_path__ + "img/facebook-icon.82a81c52.svg";